import React, { Component } from 'react';
import { Grid, Cell } from 'react-flexr';
import { FAIcon } from '../icons';

export default class SellingPoint extends Component {
  render() {
    const { text, header } = this.props;
    return (
      <Grid hAlign="center">
        <Cell
          size="1/1"
          style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '20px' }}
        >
          {header}
        </Cell>
        <Cell size={36} align="center">
          {FAIcon('ok', { style: { color: '#00cc00', fontSize: '20px' }})}
        </Cell>
        <Cell>{text}</Cell>
      </Grid>
    );
  }
}
